<template>
  <v-row>
    <v-col cols="12">
      <v-select
        v-model="form.type"
        label="Выберите тип условия"
        :items="select.type"
        @change="$emit('input', form)"
      />
    </v-col>
    <v-col
      v-if="form.type == 3"
      cols="3"
    >
      <v-text-field
        v-model="form.number"
        label="Номер реле"
        type="number"
        @change="$emit('input', form)"
      />
    </v-col>
    <v-col
      v-if="form.type == 3"
      cols="3"
    >
      <v-text-field
        v-model="form.value"
        label="Значение реле"
        type="number"
        @change="$emit('input', form)"
      />
    </v-col>
    <v-col
      v-if="form.type == 4"
      cols="3"
    >
      <v-text-field
        v-model="form.number"
        label="Номер датчика"
        type="number"
        @change="$emit('input', form)"
      />
    </v-col>
    <v-col
      v-if="form.type == 4"
      cols="3"
    >
      <v-text-field
        v-model="form.value"
        label="Значение датчика"
        type="number"
        @change="$emit('input', form)"
      />
    </v-col>
    <v-col
      v-if="form.type == 1 || form.type == 2"
      cols="12"
      class="ml-5"
    >
      <v-row
        v-for="(item, index) in form.conditions"
        :key="index"
      >
        <v-col cols="10">
          <condition
            v-model="form.conditions[index]"
            @change="$emit('input', form)"
          />
        </v-col>
        <v-col cols="2">
          <v-icon @click="form.conditions = form.conditions.filter(a=>a!=item), $emit('input', form)">
            mdi-delete
          </v-icon>
        </v-col>
      </v-row>
      <v-row class="justify-center">
        <v-col
          cols="12"
          class="text-center"
          lg="12"
          xl="6"
        >
          <v-btn
            text
            color="primary"
            @click="add_condition"
          >
            <v-icon
              large
              class="mr-2"
              color="primary"
            >
              mdi-plus-circle-outline
            </v-icon>
            Добавить новое условие
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
export default {
    props: {
        value: {
            type: Object,
            default: {
                type: 0,
                conditions: [],
                number: 0,
                value: 0
            }
        },
    },
    data () {
        return {
            select: {
                type: [
                    {
                        value: 0, text: 'Не задано'
                    },
                    {
                        value: 1, text: 'И'
                    },
                    {
                        value: 2, text: 'Или'
                    },
                    {
                        value: 3, text: 'Значение реле'
                    },
                    {
                        value: 4, text: 'Значение датчика'
                    }
                ]
            },
            form: {
                type: 0,
                conditions: [],
                number: 0,
                value: 0
            }
        }
    },
    watch: {
        value: function () {
            this.form = this.value || {}
            this.form.conditions = this.form.conditions || []
        }
    },
    mounted () {
        this.form = this.value || {
            conditions: []
        }
    },
    methods: {
        async add_condition () {
            this.form.conditions.push({})
            this.$emit('input', this.form)
        }
    }
}
</script>
